import React from 'react';
import { compile } from 'path-to-regexp';
import { Route, Redirect, useParams } from 'react-router-dom';

export type RedirectWithParamsProps = {
  to: string;
  from: string;
  exact?: boolean;
};

export type Params = Partial<Record<string, string | string[]>> | undefined;

const RedirectComponent = ({ to, exact }: RedirectWithParamsProps) => {
  const params = useParams();
  const pathTo = compile(to);
  return <Redirect exact={exact} to={pathTo(params)} />;
};

export const RedirectWithParams = ({ exact, from, to }: RedirectWithParamsProps) => {
  return (
    <Route exact={exact} path={from}>
      <RedirectComponent exact={exact} from={from} to={to} />
    </Route>
  );
};
